/* eslint-disable no-underscore-dangle */
class Event {
  constructor() {
    this._listeners = {};
  }

  on(type, fn) {
    if (typeof type === 'string' || typeof type === 'symbol') {
      if (typeof this._listeners[type] === 'undefined') {
        this._listeners[type] = [];
      }
      if (typeof fn === 'function') {
        this._listeners[type].push(fn);
        return () => this.off(type, fn);
      }
      throw new Error('event事件on的回调参数不是函数');
    } else {
      throw new Error('type类型不对:', typeof type);
    }
  }

  emit(type, ...args) {
    let result = false;
    if (typeof type === 'string' || typeof type === 'symbol') {
      const arrayEvent = this._listeners[type];
      if (arrayEvent instanceof Array) {
        result = true;
        arrayEvent.forEach((fn) => {
          if (typeof fn === 'function') {
            fn(...args);
          }
        });
      }
    } else {
      console.error('type类型不对:', typeof type);
    }
    return result;
  }

  off(type, fn) {
    let result = false;
    if (typeof type === 'string' || typeof type === 'symbol') {
      const arrayEvent = this._listeners[type];
      if (arrayEvent instanceof Array) {
        result = true;
        if (typeof fn === 'function') {
          this._listeners[type] = arrayEvent.filter((item) => item !== fn);
        } else {
          delete this._listeners[type];
        }
      }
    } else {
      console.error('type类型不对:', typeof type);
    }
    return result;
  }
}

export default Event;
